import _ from 'lodash';
import axios from 'axios';

const lGet = (...args) => _.get(...args);

export const API_URL = process.env.API_URL;

const headers = bearerToken => ({
  Authorization: `Bearer ${bearerToken}`,
  'Content-Type': 'application/json',
});

export const getAllCategories = async (bearerToken) => {
  if (!(bearerToken)) {
    throw new Error('getAllCategories: missing parameters bearerToken');
  }

  const response = await axios({
    url: `${API_URL}/definition/categories`,
    method: 'get',
    headers: headers(bearerToken),
  });

  return response.data.categories;
};

export const getAllJobs = async (bearerToken, status) => {
  if (!bearerToken) {
    throw new Error('getAllCategories: missing parameters bearerToken');
  }
  try {
    const response = await axios({
      url: `${API_URL}/categories/jobs/${status}`,
      method: 'get',
      headers: headers(bearerToken),
    });
    return lGet(response, 'data.categories', []);
  } catch(error) {
    console.log('####### getAllJobs status: ',status,' Error: ',error);
    return [];
  }

};

export const newJob = async (data, bearerToken) => {
  if (!bearerToken) {
    throw new Error('newJob: missing parameters bearerToken');
  }
  if (!data) {
    throw new Error('missing data');
  }

  const response = await axios.post(
    `${API_URL}/categories/jobs`,
    data,
    {
      headers: headers(bearerToken),
    },
  );
  return lGet(response);
};
